<template>

<core-gamename :game="gameRef" class="gamelink" />

</template>

<script>

export default {

	name: 'gameLink',

	props: ['id'],

	computed: {

		gameRef: function() {

			var game = this.$store.getters['data/games/associated'][this.id]

			return { id: this.id, name: game ? game.name : '' }

		}

	}

}

</script>

<style scoped>

.gamelink >>> .gamename-link {
	font-weight: 700;
}

.is-desktop .gamelink >>> .gamename-link:hover {
	text-decoration: underline;
}

</style>
